import * as React from 'react';
import { Eye, EyeOff, User, Lock } from 'lucide-react';

export default function LoginForm({
  email,
  setEmail,
  password,
  setPassword,
  showPassword,
  setShowPassword,
  rememberMe,
  setRememberMe,
  handleSubmit,
  passwordRef,
}) {
  return (
    <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-5 md:space-y-6">
      {/* Cédula */}
      <div>
        <label className="block text-sm sm:text-base font-medium text-gray-700 mb-2">
          Cédula
        </label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center">
            <User className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="text"
            inputMode="numeric"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-400 focus:border-transparent transition-all"
            placeholder="Número de cédula"
            required
          />
        </div>
      </div>

      {/* Password */}
      <div>
        <label className="block text-sm sm:text-base font-medium text-gray-700 mb-2">
          Contraseña
        </label>
        <p className="text-xs text-gray-500 mb-2 -mt-1">Son los últimos 4 dígitos de tu cédula.</p>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center">
            <Lock className="h-5 w-5 text-gray-400" />
          </div>
          <input
            ref={passwordRef}
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="block w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-400 focus:border-transparent transition-all"
            placeholder="••••••••"
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute inset-y-0 right-0 pr-3 flex items-center"
          >
            {showPassword ? (
              <EyeOff className="h-5 w-5 text-gray-400 hover:text-gray-600" />
            ) : (
              <Eye className="h-5 w-5 text-gray-400 hover:text-gray-600" />
            )}
          </button>
        </div>
      </div>

      {/* Remember & Forgot */}
      <div className="flex items-center justify-between">
        <label className="flex items-center cursor-pointer">
          <input
            type="checkbox"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
            className="h-4 w-4 text-gray-600 focus:ring-gray-400 border-gray-300 rounded"
          />
          <span className="ml-2 text-sm text-gray-700">Guardar Contraseña</span>
        </label>
        <button 
          type="button"
          className="text-sm text-gray-600 hover:text-gray-700 font-medium"
        >
          ¿Olvidaste tu contraseña?
        </button>
      </div>

      {/* Submit */}
      <button
        type="submit"
        className="w-full text-white py-3 px-4 rounded-lg font-semibold focus:outline-none focus:ring-2 focus:ring-offset-2 transform transition-all hover:scale-[1.02] active:scale-[0.98] shadow-lg hover:opacity-90"
        style={{ backgroundColor: '#776F74' }}
      >
        Ingresar al Sistema
      </button>
    </form>
  );
}
